export function getCreditCardFlag(number) {
  if (number.match(/^4(026|17500|405|508|844|91[37])/)) return 'visaelectron'
  if (number.match(/^4\d{12}(\d{3})?$/)) return 'visa'
  if (
    number.match(
      /^((509091)|(636368)|(636297)|(504175)|(438935)|(40117[8-9])|(45763[1-2])|(457393)|(431274)|(50990[0-2])|(5099[7-9][0-9])|(50996[4-9])|(509[1-8][0-9][0-9])|(5090(0[0-2]|0[4-9]|1[2-9]|[24589][0-9]|3[1-9]|6[0-46-9]|7[0-24-9]))|(5067(0[0-24-8]|1[0-24-9]|2[014-9]|3[0-379]|4[0-9]|5[0-3]|6[0-5]|7[0-8]))|(6504(0[5-9]|1[0-9]|2[0-9]|3[0-9]))|(6504(8[5-9]|9[0-9])|6505(0[0-9]|1[0-9]|2[0-9]|3[0-8]))|(6505(4[1-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-8]))|(6507(0[0-9]|1[0-8]))|(65072[0-7])|(6509(0[1-9]|1[0-9]|20))|(6516(5[2-9]|6[0-9]|7[0-9]))|(6550(0[0-9]|1[0-9]))|(6550(2[1-9]|3[0-9]|4[0-9]|5[0-8])))/
    )
  )
    return 'elo'
  if (number.match(/^3[47]\d{13}$/)) return 'amex'
  if (number.match(/^(5[1-5]\d{4}|677189)\d{10}$/)) return 'mastercard'
  if (number.match(/^6(?:011|5[0-9]{2})[0-9]{12}$/)) return 'discover'
  if (number.match(/^62[0-9]\d{14,17}$/)) return 'unionpay'
  if (number.match(/^9792\d{12}$/)) return 'troy'
  if (number.match(/^3(0[0-5]|[68]\d)\d{11,16}/)) return 'dinersclub'
  if (number.match(/(?:2131|1800|35[0-9]{3})[0-9]{11}$/)) return 'jcb'
  if (number.match(/^(6304|6706|6709|6771)[0-9]{12,15}$/)) return 'laser'
  if (number.match(/^5019\d{12}$/)) return 'dankort'
  if (number.match(/^1\d{14}$/)) return 'uatp'
  if (number.match(/^220[0-4]\d{12}$/)) return 'mir'
  if (number.match(/^(606282\d{10}(\d{3})?)|(3841\d{15})$/)) return 'hipercard'
  if (number.match(/^((?!504175))^((?!5067))(^50[0-9])/)) return 'aura'
  if (number.match(/(?:5[0678]\d\d|6304|6390|67\d\d)\d{8,15}$/))
    return 'maestro'

  return 'mastercard' // default type
}
